import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { alpha, Button, ButtonProps, Stack, styled } from '@mui/material'
import Result from './Result'
import ResultColor from './ResultColor.enum'

const MonoButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<ButtonProps>(() => ({
  paddingLeft: '1rem',
  paddingRight: '1rem',
  variants: [
    {
      props: ({ variant }) => variant === 'contained',
      style: {
        color: '#ffffff',
        backgroundColor: '#000000',
        '&:hover': {
          backgroundColor: alpha('#000000', 0.8),
        },
      },
    },
    {
      props: ({ variant }) => variant === 'outlined',
      style: {
        color: '#000000',
        border: '1px solid #000000',
        '&:hover': {
          backgroundColor: '#ffffff',
        },
      },
    },
  ],
}))

const NotFoundError = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const extra = useMemo(() => {
    return (
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
        <MonoButton
          variant="outlined"
          size="large"
          onClick={() => {
            navigate(-1)
          }}
        >
          {t('error.404.cta.back')}
        </MonoButton>
        <MonoButton
          variant="contained"
          size="large"
          onClick={() => navigate('/')}
        >
          {t('error.404.cta.home')}
        </MonoButton>
      </Stack>
    )
  }, [navigate, t])

  return (
    <Result
      status={404}
      title={t('error.404.title')}
      // subTitle={t('404 error')}
      description={t('error.404.description')}
      extra={extra}
      variant={ResultColor.Yellow}
    />
  )
}

export default NotFoundError
